<template xmlns="http://www.w3.org/1999/html">
    <div class="setting-page-content-wrapper features">
        <Modal
            v-if="showModal"
            @cancel="showModal = false"
            @ok="createVisitorAttribute()"
            show-footer
            :ok-text="$t('settings.create')"
            :title="$t('settings.newVisitorProfileInformation')"
            :description="$t('settings.newVisitorProfileInformationDescription')"
        >
            <VisitorAttributesForm @input="(data) => (form = data)" />
        </Modal>
        <div class="page-header">
            <div>
                <div class="title">{{ $t("settings.visitorAttribute") }}</div>
                <div class="subtitle">{{ $t("settings.visitorLoginFormSubtitles") }}</div>
            </div>
            <a-button class="add-attribute" type="primary" ghost @click="showModal = true">
                {{ $t("settings.newAdd") }}
            </a-button>
        </div>
        <section>
            <div class="fields">
                <div class="form">
                    <VisitorAttributes v-model="visitorAttributes" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import log2 from "../../../../utils/log2";
import VisitorAttributes from "../components/VisitorAttributes.vue";
import VisitorAttributesForm from "../components/VisitorAttributesForm.vue";
import Modal from "../../../../components/common/Modal2";

const log = log2("Settings/VisitorAttributesForm");
export default {
    name: "VisitorAttributePage",
    components: {
        VisitorAttributes,
        VisitorAttributesForm,
        Modal,
    },
    data: () => ({
        showModal: false,
        form: {},
    }),
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            settingInitialized: (state) => state.setting.initialized,
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            visitorAttributes: (state) => state.contactProperty.data || [],
        }),
    },
    methods: {
        ...mapActions({
            createContactProperty: "contactProperty/createContactProperty",
        }),
        createVisitorAttribute() {
            log.info("createVisitorAttribute", { data: this.form });
            this.createContactProperty(this.form).then((res) => {
                this.showModal = false;
                this.$message.success({
                    content: "Yeni Değer Kaydedildi.",
                    duration: 2,
                    key: "saved",
                });
            });
        },
    },
    mounted() {},
    watch: {},
};
</script>
<style lang="scss" scoped>
.add-attribute {
    border-color: var(--color-bg-primary-default) !important;
    color: var(--color-bg-primary-default) !important;
}
</style>
<style lang="scss">
.page-header {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between;
    align-items: center;
}
</style>
